import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  if (
    !sessionStorage.getItem("token") ||
    !sessionStorage.getItem("company_code") ||
    !sessionStorage.getItem("group_code")
  ) {
    return <Navigate to="/signin" replace />;
  }
  return children;
};

export default ProtectedRoute;
